<!--
 * @Author: your name
 * @Date: 2020-01-09 10:28:22
 * @LastEditTime : 2020-01-09 14:18:21
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\UCOverlay\MapRightClickOverlay.vue
 -->
<!--  -->
<template>
  <div>
    <div class="context_menu">

      <ul>
        <li class="near" id="id_li_poi_near">
          <i></i>
          <span>附近找</span>
        </li>
        
        <li class="start" id="id_li_route_start_point">
          <i></i>
          <span>设为起点</span>
        </li>

        <li class="mid" id="id_li_route_via_point">
          <i></i>
          <span>设为途径点</span>
        </li>

        <li class="dest" id="id_li_route_end_point">
          <i></i>
          <span>设为终点</span>
        </li>
        
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "MapRightHandButtonOverlay",
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {




    }

    




  }
};
</script>

<style lang="scss" scoped>
.context_menu {
  // background: #fff;
  width: 100px;

  li {
    float: left;
    cursor: pointer;
    padding: 5px 0px;
    width: 100px;
    margin: 0;
    display: flex;

    span {
      font-size: 12px;
    }

    i {
      background: url("../../../../assets/onlineMap/icon.png") #fff;
      width: 17px;
      height: 17px;
      background-repeat: no-repeat;
      display: inline-block;
    }
  }

  li.near {
    i {
      background-position: -189px -153px;
    }
  }

  li.start {
    border-top: 1px solid #bcc1ca;
    i {
      background-position: -123px -153px;
    }
  }

  li.mid {
    i {
      background-position: -145px -153px;
    }
  }

  li.dest {
    i {
      background-position: -167px -153px;
    }
  }
}
</style>